import { Evidence } from "./types/Evidence";
import {
  Case,
  EvidenceRequirement,
  EvidenceType,
  EvidenceStatus,
} from "../singleCase/types/Case";
import { EvidenceError } from "./types/EvidenceError";

export const sortEvidenceByTimeDescending = (evidenceList: Evidence[]) => {
  const sortedEvidenceList = [...evidenceList];
  return sortedEvidenceList.sort(
    (evidenceA, evidenceB) =>
      new Date(evidenceB.evidence.requirementSentDate).valueOf() -
      new Date(evidenceA.evidence.requirementSentDate).valueOf(),
  );
};

export const mapCaseEvidencesToEvidenceList = (cases: Case[]) => {
  const evidenceList: Evidence[] = [];

  cases.forEach((c: Case) => {
    if (c.evidences && c.evidences.length > 0) {
      c.evidences.forEach((evidence: EvidenceRequirement) => {
        const { insured, customer } = c;

        const evidenceItem = {
          insured: insured,
          customer: customer,
          evidence: evidence,
        };

        evidenceList.push(evidenceItem);
      });
    }
  });

  return sortEvidenceByTimeDescending(evidenceList);
};

export const getUnreadEvidenceCount = (cases: Case[]) => {
  const evidences = mapCaseEvidencesToEvidenceList(cases);

  return evidences.reduce((acc: number, e: Evidence) => {
    const { customerEvidenceType, customerRead, evidenceStatus } = e.evidence;

    if (customerEvidenceType === EvidenceType.ONE_WAY) {
      if (customerRead === false) {
        return acc + 1;
      }
    } else {
      if (
        evidenceStatus === EvidenceStatus.CREATED ||
        evidenceStatus === EvidenceStatus.SENT
      ) {
        return acc + 1;
      }
    }

    return acc;
  }, 0);
};

export const mergeEvidenceError = (
  evidenceErrors: EvidenceError[],
  evidenceError: EvidenceError,
) => {
  return [
    ...evidenceErrors.filter((e) => e.evidenceId !== evidenceError.evidenceId),
    evidenceError,
  ];
};

export const clearEvidenceError = (
  evidenceErrors: EvidenceError[],
  evidenceId: string,
) => {
  return evidenceErrors.filter((e) => e.evidenceId !== evidenceId);
};
